/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Peer_Support_Landing_TitleInputs */

const en_service_peer_support_landing_title = /** @type {(inputs: Service_Peer_Support_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect With Your Community`)
};

const fr_service_peer_support_landing_title = /** @type {(inputs: Service_Peer_Support_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous à votre communauté`)
};

/**
* | output |
* | --- |
* | "Connect With Your Community" |
*
* @param {Service_Peer_Support_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_peer_support_landing_title = /** @type {((inputs?: Service_Peer_Support_Landing_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Peer_Support_Landing_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_peer_support_landing_title(inputs)
	return fr_service_peer_support_landing_title(inputs)
});